import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { GenericResponseDto } from "../models/generic-response.dto";

@Injectable({
  providedIn: "root",
})
export class OrderLineItemDetailService {
  private clientManagementBaseURL = environment.baseUrl + "/ClientManagement";

  constructor(private _http: HttpClient) {}

  getClientFreightAccountNumber(
    accountNumber: string
  ): Observable<GenericResponseDto<string>> {
    return this._http.get<GenericResponseDto<string>>(
      `${this.clientManagementBaseURL}/GetClientFreightAccountNumber?AccountNumber=${accountNumber}`
    );
  }
}
